/* @moldura padrao */
import { CustomMolduraPagina } from '@/components/CustomMolduraPagina';

/** Placeholder de tela ainda não portada para o tema AdminUX. */
export function EmConstrucao({ titulo }: { titulo: string }) {
  return (
    <CustomMolduraPagina titulo={titulo} descricao="webapp-caa-ops · tema AdminUX">
      <div className="card adminuiux-card">
        <div className="card-body text-center text-secondary py-5">
          <i className="bi bi-cone-striped h1 d-block mb-2 opacity-50"></i>
          Tela em construção — será portada nas próximas fases.
        </div>
      </div>
    </CustomMolduraPagina>
  );
}
